import { render } from "./HormoneReplacementContent.vue?vue&type=template&id=38f1bf94&scoped=true"
import script from "./HormoneReplacementContent.vue?vue&type=script&lang=js"
export * from "./HormoneReplacementContent.vue?vue&type=script&lang=js"

import "./HormoneReplacementContent.vue?vue&type=style&index=0&id=38f1bf94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f1bf94"]])

export default __exports__